var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_884_8208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2122 5C20.4805 5 20.7376 5.1078 20.9256 5.29918L27.2973 11.7847C27.6851 12.1794 27.6786 12.8141 27.2829 13.2008L20.6161 19.7152C20.4292 19.8978 20.1784 20 19.9172 20H17.2526C16.3561 20 15.9125 18.9113 16.5537 18.2848L21.7418 13.2152C22.1433 12.8229 22.1433 12.1771 21.7418 11.7848L16.5537 6.71523C15.9125 6.08869 16.3561 5 17.2526 5H20.2122Z",
    fill: "url(#paint0_linear_884_8208)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_884_8208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41389 5C9.68218 5 9.93921 5.1078 10.1272 5.29918L16.499 11.7847C16.8868 12.1794 16.8803 12.8141 16.4845 13.2008L9.81771 19.7152C9.63089 19.8978 9.38004 20 9.11883 20H6.45424C5.55775 20 5.11416 18.9113 5.75536 18.2848L10.9435 13.2152C11.345 12.8229 11.345 12.1771 10.9435 11.7848L5.75535 6.71523C5.11415 6.08869 5.55775 5 6.45424 5H9.41389Z",
    fill: "url(#paint1_linear_884_8208)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_884_8208",
    x: 11.2505,
    y: 0,
    width: 21.3335,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.658824 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_884_8208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_884_8208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_884_8208",
    x: 0.452148,
    y: 0,
    width: 21.3335,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.658824 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_884_8208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_884_8208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_884_8208",
    x1: 19.5132,
    y1: 17.9643,
    x2: 29.3273,
    y2: 4.99093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#21A8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_884_8208",
    x1: 8.71489,
    y1: 17.9643,
    x2: 18.529,
    y2: 4.99093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#21A8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C1FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow);
export default __webpack_public_path__ + "static/media/card-arrow.f4658e613839dac102f01c95353e3232.svg";
export { ForwardRef as ReactComponent };